/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_AnkleInputs */

const en_us2_profile_editors_pain_area_ankle = /** @type {(inputs: Profile_Editors_Pain_Area_AnkleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankle`)
};

const pt_br2_profile_editors_pain_area_ankle = /** @type {(inputs: Profile_Editors_Pain_Area_AnkleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornozelo`)
};

const es_419_profile_editors_pain_area_ankle = /** @type {(inputs: Profile_Editors_Pain_Area_AnkleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tobillo`)
};

const pt_pt2_profile_editors_pain_area_ankle = /** @type {(inputs: Profile_Editors_Pain_Area_AnkleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornozelo`)
};

const fr_fr2_profile_editors_pain_area_ankle = /** @type {(inputs: Profile_Editors_Pain_Area_AnkleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheville`)
};

const de_de2_profile_editors_pain_area_ankle = /** @type {(inputs: Profile_Editors_Pain_Area_AnkleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knöchel`)
};

const it_it2_profile_editors_pain_area_ankle = /** @type {(inputs: Profile_Editors_Pain_Area_AnkleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caviglia`)
};

/**
* | output |
* | --- |
* | "Ankle" |
*
* @param {Profile_Editors_Pain_Area_AnkleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_ankle = /** @type {((inputs?: Profile_Editors_Pain_Area_AnkleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_AnkleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_ankle(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_ankle(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_ankle(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_ankle(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_ankle(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_ankle(inputs)
	return en_us2_profile_editors_pain_area_ankle(inputs)
});
export { profile_editors_pain_area_ankle as "profile-editors.pain_area_ankle" }